export enum UserRole {
  SuperAdmin = 'SUPER_ADMIN',
  TenantAdmin = 'TENANT_ADMIN',
  Owner = 'OWNER',
  Manager = 'MANAGER',
  Mechanic = 'MECHANIC',
  Stock = 'STOCK',
  Sales = 'SALES',
}
